/*
 * @LastEditors: 杨钊
 * @Date: 2020-03-26 14:22:59
 * @LastEditTime: 2020-04-04 14:40:30
 * @FilePath: /tiger-web/src/main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// import axios from 'axios'
// axios.defaults.baseURL='/'
// import VueAxios from 'vue-axios'
// Vue.use(VueAxios, axios)

import $ from 'jquery'
import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/js/bootstrap"

import "assets/css/newland.4.css"
import "assets/css/iconfont.css"
import _Global from "./components/Global.vue"
Vue.prototype._Global=_Global

import Vant from 'vant';
import 'vant/lib/index.css';

Vue.use(Vant);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import common from "assets/js/common"
Vue.use(common)

Vue.config.productionTip = false

import resource from 'vue-resource'
Vue.use(resource)

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import layer from 'vue-layer'
Vue.prototype.$layer = layer(Vue);

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

Vue.http.options.emulateJSON = true
Vue.filter("formatDateTime",function(inputTime) {
  if (!inputTime){
    return ""
  }
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  var d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  var h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second;
})

import 'vue-paginator-simple/dist/vue-paginator-simple.css';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js